import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { EvidenceOptionType } from "../../hooks/evidences/typyng"
import { typeUser } from "../../pages/questionnaire/pages/detail/methods/actionPlan/contants"
import { EvidencesTypeEnum } from "../../utils/enums/evidences"


const useEvidenceListType = ({ optionType }: { optionType?: EvidenceOptionType }) => {
    const { t } = useTranslation()
    const userList = [
        {
            label: t('general.listEvidence.creator'),
            value: '1',
            type: typeUser.CREATOR
        },
        {
            label: t('general.listEvidence.solver'),
            value: '2',
            type: typeUser.SOLVER
        },
    ]
    const folioManagementList = [
        {
            label: t('general.listEvidence.approved'),
            value: '1',
            type: typeUser.APPROVER,
            option: EvidencesTypeEnum.OBSERVATION_COMMENT
        },
        {
            label: t('general.listEvidence.reject'),
            value: '2',
            type: typeUser.REJECT,
            option: EvidencesTypeEnum.OBSERVATION_COMMENT
        },
    ]
    const creationList = [
        {
            label: t('general.listEvidence.approved'),
            value: '1',
            type: typeUser.CREATE,
        },
    ]

    const list: {
        label: string;
        value: string;
        type?: string | null;
        option?: string;
    }[] = useMemo(() => {
        if (optionType == EvidenceOptionType.CREATOR) {
            return userList
        }
        if (optionType == EvidenceOptionType.FOLIO_MANAGEMENT) {
            return folioManagementList
        }
        if (optionType == EvidenceOptionType.CREATION) {
            return creationList
        }
        return []
    }, [])
    return { list }
}

export { useEvidenceListType }